import React, { Component } from "react";

import Code from "./code";

class Interactions extends Component {
  constructor(props) {
    super(props);
    this.syntax =
      "smxProxy.sendRequest (\n\tstring interaction, // see list of available interactions names\n\tobject parameter, // JSON object according to interaction definition\n\tstring callback // name of the function that will be called with the result\n);";
    this.getcontext =
      '//get context\nsmxProxy.sendRequest("get-context", null, "onContext");';
    this.requestCommit =
      '//request to commit changes\nsmxProxy.sendRequest("request-commit", {"commands" : [ "add host ...","add host ..." ]}, "onCommit");\n\n...\n\n//callback\nfunction onCommit(value) {\n\tvar result = JSON.stringify(value);\n\t//do something with the JSON formatted context\n}';
    this.goToRule =
      '//navigate to rule\nsmxProxy.sendRequest("go-to-rule",	{ "rule-id" : " 6c488338-8eec-4103-ad21-cd461ac2c476"} );';
    this.closeWindow =
      '//close extension window\nsmxProxy.sendRequest("close-window");';
    this.runReadonly =
      '//run readonly command\nsmxProxy.sendRequest("run-readonly-command",\n\t{"command" : "show gateways-and-servers","parameters" : {"details-level":"full"}},\n\t"onReadOnlyCommand");';
  }
  render() {
    return (
      <div>
        <p>
          An extension can use JavaScript to interact with SmartConsole. The
          interactions provide access to information, such as the extension
          location context, and can perform certain basic operations. For
          example, navigate to a rule. Interactions can return data
          asynchronously by matching callbacks.
        </p>
        <p>
          To use an interaction, call the JavaScript function
          smxProxy.sendRequest with the name of the interaction as the first
          parameter, followed by the interaction parameters (if there are any).
        </p>
        <p>
          <b>Note -</b> SMX is an abbreviation for SmartConsole Extensions.
        </p>
        <h4>smxProxy.sendRequest function syntax</h4>
        <Code>{this.syntax}</Code>
        <br />
        <table cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <th className="table-top-header-left">
                <p>
                  <span>Name</span>
                </p>
              </th>
              <th className="table-top-header-left fit-content">
                <p>
                  <span>Min. Version</span>
                </p>
              </th>
              <th className="table-top-header-right">
                <p>
                  <span>Description</span>
                </p>
              </th>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>get-context</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p />
                <p>
                  <span>
                    Returns a JSON structure that contains all context
                    parameters.
                  </span>
                </p>
                <p>
                  <span>
                    <b>Parameters:</b>
                  </span>
                </p>
                <p>
                  <span className="italic">None</span>
                </p>
                <p>
                  <span>
                    <b>Return:</b>
                  </span>
                </p>
                <p>
                  <span className="italic">
                    JSON object of extension location context. See{" "}
                    <a href="#Extension Context">Extension Context</a>.
                  </span>
                </p>
                <p>
                  <span>
                    <b>Note:</b> Starting from version 1.3, When you set <b>minimum-version</b> or <b>force-version</b> to 1.3 in the manifest,  the callback will be invoked both on the first call and whenever the context changes, returning the current context each time.
                  </span>
                </p>
                <Code>{this.getcontext}</Code>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>request-commit</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    Presents the user a dialog requesting to commit the
                    specified API commands.
                    <br />
                    Note - Most Session Management commands are not supported
                    through SmartConsole CLI thus also through this interaction.
                    See Management API documentation whether a command specifies the
                    “--format JSON” option, the corresponding response will also
                    be a JSON structure.
                  </span>
                </p>
                <p>
                  <span>
                    <b>Parameters:</b>
                  </span>
                </p>
                JSON object constructed from list of SmartConsole CLI commands.
                See Management API documentation.
				The last argument is the name of the callback function to be called when the API commands have been executed.
                <br />
                <br />
                <p>
                  <span>
                    <b>Return:</b>
                  </span>
                </p>
                <p>
                  <span className="italic">
                    JSON object of commands results.
                  </span>
                </p>
                <Code>{this.requestCommit}</Code>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>go-to-rule</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span> </span>
                </p>
                <p>
                  <span>
                    Execute navigation inside SmartConsole to provided rule UID.
                  </span>
                </p>
                <p>
                  <span>
                    <b>Parameters:</b>
                  </span>
                </p>
                <p>
                  <span className="italic">
                    JSON object constructed from rule id.
                  </span>
                </p>
                <p>
                  <span>
                    <b>Return:</b>
                  </span>
                </p>
                <p>
                  <span className="italic">None.</span>
                </p>
                <Code>{this.goToRule}</Code>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>close-window</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    Closes the extension window (relevant for browser-window
                    items only).
                  </span>
                </p>
                <p>
                  <span>
                    <b>Parameters:</b>
                  </span>
                </p>
                <p>
                  <span className="italic">None.</span>
                </p>
                <p>
                  <span>
                    <b>Return:</b>
                  </span>
                </p>
                <p>
                  <span className="italic">None.</span>
                </p>
                <Code>{this.closeWindow}</Code>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>run-readonly-command</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.2</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    Execute specified read-only API command.
                    <br />
                    Note - Most Session Management commands are not supported
                    through SmartConsole CLI thus also through this interaction.
                    <br />
                    Requires{" "}
                    <a href="#Extension Permissions">
                      run-read-only-commands
                    </a>{" "}
                    permission
                  </span>
                </p>
                <p>
                  <span>
                    <b>Parameters:</b>
                  </span>
                </p>
                <p>
                  <span className="italic">
                    JSON object composed of the API command name and
                    command-parameters. See Management API documentation.
                  </span>
                </p>
                <p>
                  <span>
                    <b>Return:</b>
                  </span>
                </p>
                <p>
                  <span className="italic">JSON object of command result.</span>
                </p>
                <Code>{this.runReadonly}</Code>
                <p />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default Interactions;
